'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placement", "overlay", "onShow", "onHide"];
import React, { cloneElement, isValidElement } from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { useTrigger } from "../../hooks/useTrigger.mjs";
import { Trigger } from "./Trigger.mjs";
var DropdownTriggerComponent = function DropdownTriggerComponent(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    overlay = _ref.overlay,
    _ref$onShow = _ref.onShow,
    onShow = _ref$onShow === void 0 ? function () {} : _ref$onShow,
    _ref$onHide = _ref.onHide,
    onHide = _ref$onHide === void 0 ? function () {} : _ref$onHide,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTrigger = useTrigger({
      overlay: overlay,
      onShow: onShow,
      onHide: onHide
    }),
    triggerRef = _useTrigger.triggerRef,
    onClick = _useTrigger.onClick,
    onKeyDown = _useTrigger.onKeyDown;
  return /*#__PURE__*/React.createElement(Trigger, Object.assign({
    ref: triggerRef,
    overlay: overlay && typeof overlay === 'object' && /*#__PURE__*/isValidElement(overlay) && /*#__PURE__*/cloneElement(overlay),
    placement: placement,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.DropdownTrigger
  }));
};
var dropdownTriggerHelpers = {
  /**
   * @deprecated
   * Use placement="top" instead.
   */
  top: 'top',
  /**
   * @deprecated
   * Use placement="bottom" instead.
   */
  bottom: 'bottom'
};

/**
 * DropdownTrigger makes the dropdown appear on user interaction.
 * Our triggers are not viewport-aware and may render off screen in more dynamic situations.
 * Consider a library such as [Tippy.mjs](https://atomiks.github.io/tipp.mjs/) or [Floating UI](https://floating-ui.com/) if you need smarter positioning.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-dropdown-dropdowntrigger--docs) |
 * [Encore site](https://encore.spotify.net/web/components/dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/DropdownTrigger)
 */
export var DropdownTrigger = Object.assign(DropdownTriggerComponent, dropdownTriggerHelpers);